import { formatPriceDataLayer } from '@SHARED/js/helpers/misc';

export default class {
  constructor(attributes = {}) {
    const defaultAttributes = {
      authUserHash: null,
      dateAdded: null,
      id: null,
      vismaId: '',
      name: '',
      price: null,
      customerPrices: [],
      quantity: null,
      referralUrl: '',
      thumbnail: '',
      variant: null,
      weight: null,
    };

    Object.assign(
      this,
      defaultAttributes,
      attributes,
    );
  }

  getQuantityDiscountPrice() {
    let agreedPrice = null;

    if (this.customerPrices) {
      // This is the JS equivalent to Product@getAgreedPrice()
      this.customerPrices.forEach((price) => {
        if ((price.from_quantity <= this.quantity &&
             price.to_quantity >= this.quantity &&
             price.to_quantity !== null)
            ||
            (price.from_quantity <= this.quantity &&
             price.to_quantity === null)
        ) {
          agreedPrice = price.agreed_price;
        }
      });
    }

    return parseFloat(agreedPrice || this.price);
  }

  getPrice() {
    let price = this.getQuantityDiscountPrice();

    if (this.variant && this.variant.additional_price) {
      price += parseFloat(this.variant.additional_price);
    }

    return price;
  }

  getDataLayerObject() {
    let productDataLayer = {};

    if (
      typeof window.productDataLayer !== 'undefined' &&
      window.productDataLayer.ecommerce.detail.products.length === 1 &&
      window.productDataLayer.ecommerce.detail.products[0].id === this.vismaId
    ) {
      // Find and retrieve product dataLayer object from global scope
      productDataLayer = window.productDataLayer.ecommerce.detail.products[0];
    }

    let variantName = null;

    if (this.variant) {
      variantName = this.variant.name;
    }

    return {
      name: this.name,
      id: this.vismaId,
      price: formatPriceDataLayer(this.getPrice()), // Ex tax
      brand: 'Kraftex',
      category: this.category || 'Ikke satt',
      variant: variantName || 'Standard',
      quantity: this.quantity,
    };
  }
}
